import { render, staticRenderFns } from "./SetUnreadBtn.vue?vue&type=template&id=70272471&scoped=true&"
import script from "@/scripts/QA/Question/components/SetUnreadBtn?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/SetUnreadBtn?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70272471",
  null
  
)

export default component.exports